var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimeToClimbIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M43.656 40.678a1.346 1.346 0 0 1-.999 2.237h-5.29a.725.725 0 0 0-.093-.363c-.107-.187-2.744-4.588-13.638-4.952-5.159-.173-7.553-1.681-7.593-3.01-.035-1.13 1.74-2.503 5.098-2.824 5.362-.513 6.44-2.531 6.606-3.689.236-1.646-1.14-3.323-3.503-4.273-.751-.302-1.208-.73-1.395-1.31-.36-1.11.347-2.605.65-3.089a.72.72 0 0 0 .109-.353l20.048 21.626zm-20.068-1.621c8.135.272 11.253 2.885 12.137 3.858H5.338c-.344 0-.674-.133-.923-.371a1.348 1.348 0 0 1-.046-1.9L22.03 19.063c-.385.76-1.043 2.382-.564 3.874.323 1.007 1.076 1.754 2.239 2.222 1.693.68 2.74 1.77 2.605 2.712-.135.95-1.601 2.09-5.307 2.444-4.507.432-6.467 2.481-6.41 4.321.06 1.994 2.456 4.202 8.995 4.422zM28.47 9.376l-1.126.192a.303.303 0 0 0-.167.516l.792.776c.071.07.104.17.087.268l-.187 1.096a.3.3 0 0 0 .437.319l.98-.518a.3.3 0 0 1 .28 0l.979.518a.3.3 0 0 0 .437-.32l-.187-1.095a.304.304 0 0 1 .087-.268l.792-.775a.303.303 0 0 0-.167-.517l-1.095-.16a.301.301 0 0 1-.227-.165l-.49-.996a.3.3 0 0 0-.54 0l-.425.928a.352.352 0 0 1-.26.2zm-5.268 8.987a.72.72 0 0 0-.848.157V5.521c0-.195.157-.353.352-.354h.143c.195 0 .352.159.352.354v.66c1-.386 3.634-1.158 6.224.18 3.283 1.696 6.648 0 6.648 0v8.405s-3.962 1.361-6.648 0c-2.155-1.093-5.132-.431-6.223-.128v3.725z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#00A8FF",
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h48v48H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimeToClimbIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/time-to-climb-icon.644643ea7fccabf1736f78915997a370.svg";